import { useNavigate, useLocation } from 'react-router-dom';
import './Footer.css';

const navLinks = [
  { label: 'Home',       hash: 'home'       },
  { label: 'About',      hash: 'about'      },
  { label: 'Tokenomics', hash: 'tokenomics' },
  { label: 'Roadmap',    hash: 'roadmap'    },
];

export default function Footer() {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  function scrollToSection(hash) {
    if (pathname === '/') {
      const el = document.getElementById(hash);
      if (el) el.scrollIntoView({ behavior: 'smooth' });
    } else {
      navigate(`/#${hash}`);
    }
  }

  return (
    <footer className="footer">
      <div className="container footer-inner">
        <div className="footer-brand">
          <span className="footer-logo">MEME<span className="footer-logo-cult">CULT</span>URE</span>
          <p>The index of meme culture on Ethereum.</p>
          <span className="footer-ticker">$CULT</span>
        </div>

        <div className="footer-links">
          <div className="footer-col">
            <h4>Navigate</h4>
            {navLinks.map(({ label, hash }) => (
              <button key={hash} onClick={() => scrollToSection(hash)}>{label}</button>
            ))}
          </div>
          <div className="footer-col">
            <h4>Community</h4>
            <a href="https://x.com/MemeCultureETH" target="_blank" rel="noopener noreferrer">Twitter / X</a>
            <a href="https://t.me/memecultureeth" target="_blank" rel="noopener noreferrer">Telegram</a>
          </div>
          <div className="footer-col">
            <h4>Token</h4>
            <a href="https://etherscan.io/token/0xaab77ed699f42ebc44edcf37d115c2a70414da2c" target="_blank" rel="noopener noreferrer">Etherscan</a>
            <a href="https://app.uniswap.org/swap?outputCurrency=0xaab77ed699f42ebc44edcf37d115c2a70414da2c" target="_blank" rel="noopener noreferrer">Uniswap</a>
            <a href="https://dexscreener.com/ethereum/0xaab77ed699f42ebc44edcf37d115c2a70414da2c" target="_blank" rel="noopener noreferrer">Dexscreener</a>
          </div>
        </div>
      </div>
      <div className="footer-bottom">
        <div className="container">
          <p>© 2026 Meme Culture · $CULT</p>
        </div>
      </div>
    </footer>
  );
}
